import { Creators } from "model/updater"
import createModule from "../createModule"
import view from "./view"
import { getAvailablePortfolios, getSelectedPortfolios } from "./selectors/portfolios"
import { getUpdateUrl } from "./selectors/urls"
import { getEmails } from "./selectors/emails"

export default createModule({
  view,
  externalProps: state => ({
    account: state.global.selected.account,
  }),
  required: ["account", "userId"],
  data: [{
    resource: "subscriptions",
    url: ({ account, userId }) => `/api/${account}/users/${userId}/subscriptions`,
  }, {
    resource: "portfolios",
    url: ({ account }) => `/api/${account}/portfolios`,
  }],
  mapStateToProps: (state, props) => ({
    availablePortfolios: getAvailablePortfolios(state),
    selectedPortfolios: getSelectedPortfolios(state),
    emails: getEmails(state),
    updateUrl: getUpdateUrl(state, props),
  }),
  actions: { update: Creators.update },
})
